import { render, staticRenderFns } from "./schBudInternet.vue?vue&type=template&id=a301cb68&scoped=true&"
import script from "./schBudInternet.vue?vue&type=script&lang=js&"
export * from "./schBudInternet.vue?vue&type=script&lang=js&"
import style0 from "./schBudInternet.vue?vue&type=style&index=0&id=a301cb68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a301cb68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
